import api, { transformRequest, transformResponse } from "services/api";

export const military = api
  .enhanceEndpoints({
    addTagTypes: ["Military"],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      fetchAllDebtorMilitary: build.query({
        query: (payload) => `/api/v1/core/debtors/${payload.debtorId}/military/`,
        transformResponse: (response) => transformResponse(response),
        providesTags: (results) =>
          results
            ? // successful query
              [
                ...results.map(({ id }) => ({ type: "Military", id })),
                { type: "Military", id: "LIST" },
              ]
            : // an error occurred, but we still want to refetch this query when `{ type: 'Military', id: 'LIST' }` is invalidated
              [{ type: "Military", id: "LIST" }],
      }),
      fetchDebtorMilitary: build.query({
        query: (payload) =>
          `/api/v1/core/debtors/${payload.debtorId}/military/${payload.militaryId}/`,
        transformResponse: (response) => transformResponse(response),
        providesTags: (results) => (results ? [{ type: "Military", id: results.id }] : []),
      }),
      createDebtorMilitary: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtors/${payload.debtorId}/military/create/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        invalidatesTags: [{ type: "Military", id: "LIST" }],
      }),
      updateDebtorMilitary: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtors/${payload.debtorId}/military/${payload.militaryId}/update/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        invalidatesTags: [{ type: "Military", id: "LIST" }],
      }),
      deleteDebtorMilitary: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtors/${payload.debtorId}/military/${payload.militaryId}/delete/`,
          method: "POST",
        }),
        invalidatesTags: [{ type: "Military", id: "LIST" }],
      }),
    }),

    overrideExisting: false,
  });

export const {
  useFetchAllDebtorMilitaryQuery,
  useFetchDebtorMilitaryQuery,
  useCreateDebtorMilitaryMutation,
  useUpdateDebtorMilitaryMutation,
  useDeleteDebtorMilitaryMutation,
} = military;
